// extracted by mini-css-extract-plugin
module.exports = {"box":"box_yBH9P","boxInfo":"boxInfo_-g5lA","boxRole":"boxRole_Kudbe","arrow":"arrow_GB-Ix","item":"item_+a6BH"};